import { render, staticRenderFns } from "./VircosGraphics2.vue?vue&type=template&id=7f3cd4b8&scoped=true&"
import script from "./VircosGraphics2.vue?vue&type=script&lang=js&"
export * from "./VircosGraphics2.vue?vue&type=script&lang=js&"
import style0 from "./VircosGraphics2.vue?vue&type=style&index=0&id=7f3cd4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3cd4b8",
  null
  
)

export default component.exports